import {
	default as React,
	type ReactNode,
	createContext,
	useContext,
	useEffect,
} from "react";
import { useComplexState } from "use-complex-state";
import { searchSettings } from "../configuration/pages/settings/SettingsPage";
import { useMesfRealtime } from "../hooks/useMesfRealtime";
import {
	type SettingModel,
	UTLSettingsReducer,
} from "../reducers/UTLSettingsReducer";

const UTLSettingsContext = createContext({
	state: UTLSettingsReducer.getInitialState(),
	actions: UTLSettingsReducer.actions,
	isLoading: true,
});

export const useUTLSettingsContext = () => useContext(UTLSettingsContext);

export const UTLSettingsProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: UTLSettingsReducer.getInitialState(),
		reducers: UTLSettingsReducer.caseReducers,
	});

	const {
		data: rows,
		isLoading,
		isError,
		error: e,
		isSuccess,
		refetch,
	} = searchSettings();

	useEffect(() => {
		if (isSuccess) {
			const settings = rows as SettingModel[];
			const settingsTrimmed = settings.map((setting) => ({
				...setting,
				SettingName: setting.SettingName.trim(),
			}));
			actions.initSettings(settingsTrimmed);
		}
	}, [isSuccess]);

	useEffect(() => {
		if (e && isError) {
			console.error(e.message);
		}
	}, [e, isError]);

	useMesfRealtime({
		topics: ["UTL.GetSettings"],
		onMessage: () => refetch(),
	});

	return (
		<UTLSettingsContext.Provider value={{ state, actions, isLoading }}>
			{children}
		</UTLSettingsContext.Provider>
	);
};
